
import * as yup from 'yup';

const local_language = localStorage.getItem('lang')



const OwnerDetailValidation = yup.object().shape({
    experience: yup.string()
        .required(local_language == "alb" ? "Ju lutemi shkruani përvojën tuaj" : 'Please enter your experience')
        .matches(/^(0\.[1-9]|[1-9][0-9]?(\.[0-9])?)$/, {
            message: local_language == "alb" ? "Ju lutemi shkruani përvojën e saktë. Shembuj: 0.2 vjet, 2 vjet, 20 vjet." :'Please enter correct experience. Examples: 0.2 years, 2 years, 20 years',
        })
        .test('max', local_language == "alb" ? "Eksperienca nuk mund të jetë më e madhe se 20 vjet." :'Experience cannot be greater than 20 years.', (value) => {
            const experience = parseFloat(value);
            return experience <= 20;
        }),
    profile_image: yup.mixed()
        .test('is-file', local_language == "alb" ? "Kërkohet imazhi i profilit." :'Profile image is required.', function (value: any) {
            return value && value.length > 0;
        }),


});

export default OwnerDetailValidation;
